/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./keyValueEditor.vue?vue&type=template&id=7894b654&scoped=true"
import script from "./keyValueEditor.vue?vue&type=script&lang=js"
export * from "./keyValueEditor.vue?vue&type=script&lang=js"
import style0 from "./keyValueEditor.vue?vue&type=style&index=0&id=7894b654&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7894b654",
  null
  
)

export default component.exports